/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_Col_SourceInputs */

const en_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const de_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle`)
};

const fr_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const it_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const nl_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bron`)
};

const pl_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródło`)
};

const fi_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähde`)
};

const da_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const sv_analytics_board_col_source = /** @type {(inputs: Analytics_Board_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Källa`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Analytics_Board_Col_SourceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_col_source = /** @type {((inputs?: Analytics_Board_Col_SourceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_Col_SourceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_col_source(inputs)
	if (locale === "fr") return fr_analytics_board_col_source(inputs)
	if (locale === "es") return es_analytics_board_col_source(inputs)
	if (locale === "it") return it_analytics_board_col_source(inputs)
	if (locale === "nl") return nl_analytics_board_col_source(inputs)
	if (locale === "pl") return pl_analytics_board_col_source(inputs)
	if (locale === "fi") return fi_analytics_board_col_source(inputs)
	if (locale === "da") return da_analytics_board_col_source(inputs)
	if (locale === "sv") return sv_analytics_board_col_source(inputs)
	return en_analytics_board_col_source(inputs)
});